import ValidSignAccountDetailDrawer from './ValidSignAccountDetailDrawer';

export default ValidSignAccountDetailDrawer;
